var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 366.28 524.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{stroke:#fff;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-3{stroke:#000;stroke-width:0.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhitePage"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "295.29 121.29 295.49 386.09 30.5 386.09 30.5 66.09 235.42 66.59 295.29 121.29"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "329.05 130.95 365.59 155.14 295.29 262.01 295.33 182.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "295.49 386.09 30.5 386.09 30.5 66.09 235.77 66.09 234.74 121.18 295.49 121.65 295.49 168.59 279.53 168.59 279.53 137.49 218.48 137.02 219.51 82.05 46.45 82.05 46.45 370.14 279.53 370.14 279.53 298.84 295.49 298.84 295.49 386.09"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.99,
    y: 59.28,
    width: 15.96,
    height: 81.09,
    transform: "translate(10.91 224.41) rotate(-47.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.55,
    y: 157.7,
    width: 170.3,
    height: 15.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.55,
    y: 197.59,
    width: 170.3,
    height: 15.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.55,
    y: 237.49,
    width: 162.32,
    height: 15.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.55,
    y: 277.39,
    width: 114.45,
    height: 15.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.55,
    y: 317.28,
    width: 114.45,
    height: 15.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.11,332.86,227,285.74l71.66-108.25,36.54,24.18L263.56,309.93Zm20.39-41.57-1.34,12.8,11.26-6.24,60.69-91.68-9.91-6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.05,212.71l-36.53-24.18L329.05,131l36.54,24.19ZM313.54,184l9.92,6.57,20.11-30.84-9.92-6.57Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b8058dc33277e6fb7830d2f41cd16bb7.svg";
export { ForwardRef as ReactComponent };